import { useFlagValue } from './utils';
const FLAG_ID = 21;

export const useNewtonRecEnabled = (): boolean => {
  const flagValue = useFlagValue(FLAG_ID);
  return flagValue === 'true';
};
